import { parseAtValue } from '#app/helpers/dateFieldTransforms';
import { Money } from 'finhelper';

export const getPlanIncome = (item) => {
  return item?.plan_income ? Money.toDigits(item.plan_income) : 0;
};

export const getOutcome = (item) => {
  return item?.outcome ? Money.toDigits(item.outcome) : 0;
};

export const getAdditionalIncome = (item) => {
  return item?.additional_income ? Money.toDigits(item.additional_income) : 0;
};

export const getObligation = (item) => {
  return item?.obligation ? Money.toDigits(item.obligation) : 0;
};

export const getRetiredIncome = (item) => {
  return item?.retired_goals ? Money.toDigits(item.retired_goals) : 0;
};

export const getAdditionalOutcome = (item) => {
  return item?.additional_outcome ? Money.toDigits(item.additional_outcome) : 0;
};

export const getChartData = (client, items, type, incomeField, retiredAge, deadAge) => {
  const result = [];
  let data = [];

  let isRetire = false;
  const retiredDate = parseAtValue(client?.birth_at).add(retiredAge, 'year');
  const deadDate = parseAtValue(client?.birth_at).add(retiredAge, 'year').add(deadAge, 'year');

  // Карьера
  if (type === 'salary' || type === 'all') {
    if (Array.isArray(items) && items.length > 0) {
      items.forEach((item) => {
        const buyDate = parseAtValue(item?.buy_at);
        if (buyDate.isSameOrBefore(retiredDate)) {
          data.push(item);
        }
      });
    }
  }

  // Дополнительные данные для salary
  if (type === 'salary') {
    let i = 0;
    if (Array.isArray(items) && items.length > 0) {
      items.forEach((item) => {
        const buyDate = parseAtValue(item?.buy_at);
        if (i < 3 && buyDate.isAfter(retiredDate) && buyDate.isSameOrBefore(deadDate)) {
          item.added = true;
          data.push(item);
          i++;
        }
      });
    }
  }

  // Пенсия
  if (type === 'retirement') {
    isRetire = true;
    let i = 0;
    if (Array.isArray(items) && items.length > 0) {
      items.forEach((item) => {
        const buyDate = parseAtValue(item?.buy_at);
        if (i < 3 && buyDate.isAfter(retiredDate.clone().subtract(3, 'years'))) {
          item.added = true;
          data.push(item);
          i++;
        }
      });
    }
  }

  if (type === 'retirement' || type === 'all') {
    if (Array.isArray(items) && items.length > 0) {
      items.forEach((item) => {
        const buyDate = parseAtValue(item?.buy_at);
        if (buyDate.isAfter(retiredDate) && buyDate.isSameOrBefore(deadDate)) {
          data.push(item);
        }
      });
    }
  }

  // Формирование результата
  if (Array.isArray(data) && data.length > 0) {
    data.forEach((item, key) => {
      const income = Money.toDigits(item[incomeField]);
      const outcome = getOutcome(item) + getObligation(item) + getAdditionalOutcome(item);
      const clear = getPlanIncome(item) + getAdditionalIncome(item) + getRetiredIncome(item);

      result.push({
        key,
        id: item.id,
        isRetire,
        date: `${item.year}-01-01`,
        income,
        outcome,
        clear,
        open: income > outcome ? outcome : income,
        close: income > outcome ? income : income,
      });
    });
  }

  return result;
};

export const getChartBiggestValue = (data) => {
  let value = 1000;

  if (!Array.isArray(data)) return value * 1.2;

  data.forEach((item) => {
    if (item.income > value) value = item.income;
    if (item.outcome > value) value = item.outcome;
    if (item.clear > value) value = item.clear;
  });

  return value * 1.2;
};
